import { AppKeyEnum, PlatformEnum } from '@/constants/enum';
import i18n from '@/i18n';
import { Banner, BlockStack } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';
import RegularText from '../RegularText';
import { cmsApiCaller } from '@/redux/query/cms-admin';

const STORAGE_KEY = 'hide_holiday_banner';

export default function HolidayBanner() {
  const [isHide, setIsHide] = useState<Record<string, boolean>>(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'));

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(isHide));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(isHide)]);

  const { data } = cmsApiCaller.useGetHolidayBannerQuery({
    appKey: AppKeyEnum.BlockifyAgeVerification,
    platform: PlatformEnum.Wix,
    languageCode: i18n.language,
  });

  const banners = useMemo(() => {
    const banners = data?.data || [];
    return banners
      .map((banner) => {
        if (!banner.isActive) return undefined;
        const { bannerTranslations, ...rest } = banner;

        const activeTranslations = bannerTranslations.filter((t) => t.isActive);
        const translation = activeTranslations.find((t) => t.languageCode === i18n.language) || activeTranslations[0];

        if (!translation) return undefined;

        return {
          ...rest,
          title: translation.title,
          description: translation.description,
        };
      })
      .filter((banner) => !!banner)
      .sort((a, b) => (a?.priority || 0) - (b?.priority || 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  const handleHideBanner = (key: string) => {
    setIsHide((prev) => ({ ...prev, [key]: true }));
  };

  return (
    <BlockStack>
      {banners.map((banner) =>
        !isHide[banner?.bannerKey || ''] ? (
          <Banner
            key={banner?.id}
            title={banner?.title}
            onDismiss={banner?.isShowDismissBtn ? () => handleHideBanner(banner?.bannerKey || '') : undefined}
            tone={banner?.tone}
          >
            <BlockStack>
              {banner?.description.map((description) => (
                <RegularText key={description}>{description}</RegularText>
              ))}
            </BlockStack>
          </Banner>
        ) : null,
      )}
    </BlockStack>
  );
}
